module.exports = __webpack_public_path__ + "static/media/cis-logo.43fe3cf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cis-logo.png
// module id = 562
// module chunks = 0